import React, { useEffect, useState } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Products from "../components/products";
import { useSelector, useDispatch } from "react-redux";
import { listProducts } from "../actions/productActions";
import LoadingBox from "../components/loadingBox";
import MessageBox from "../components/messageBox";
import Carousel from "../components/carousel";
import MainPage from "../components/mainPage";
import MainNextPage from "../components/mainNextPage";

function HomePage(props) {
  const productList = useSelector((state) => state.productList);
  const { products, loading, error } = productList;
  // console.log(products);
  // console.log(productList);

  const dispatch = useDispatch();

  //fetch data
  useEffect(() => {
    dispatch(listProducts({}));
  }, [dispatch]);

  return (
    <div>
      {loading ? (
        <LoadingBox />
      ) : error ? (
        <MessageBox variant="danger">{error}</MessageBox>
      ) : (
        <div>
          <NavBar />
          <Carousel />
          <MainPage />

          <div className="products bg-light ">
            <Products products={products.products} />
          </div>
          <MainNextPage />
          <Footer />
        </div>
      )}
    </div>
  );
}

export default HomePage;

// function HomePage(props) {
//   const productList = useSelector((state) => state.productList);
//   const { products, loading, error } = productList;
//   console.log(products);
//   console.log(productList);

//   const dispatch = useDispatch();

//   //fetch data
//   useEffect(() => {
//     dispatch(listProducts({}));
//   }, [dispatch]);

//   return (
//     <div>
//       {loading ? (
//         <LoadingBox />
//       ) : error ? (
//         <MessageBox variant="danger">{error}</MessageBox>
//       ) : (
//         <div>
//           <NavBar />
//           <Carousel />
//           <MainPage />

//           <div className="products bg-light ">
//             <Products products={products.products} />
//           </div>
//           <MainNextPage />
//           <Footer />
//         </div>
//       )}
//     </div>
//   );
// }

// export default HomePage;
